// Espelha CONTEXT_EMAIL_RE de
// scriptamo2/src/backfill-canonical-user-access/index.ts:167.
//
// As duas listas PRECISAM concordar: o backfill usou exatamente esta regra para
// decidir quais usuários receberiam os user_seller_group dos seus logins
// antigos. Se uma variante de tag for adicionada lá, adicione aqui também.
export const CONTEXT_EMAIL_RE =
  /([+_]log|[+._]go|[+]hml|[+]sandbox|[-+]teste)(?=@)/i;

/**
 * Canônico = e-mail sem tag de contexto (`cliente@empresa.com`).
 *
 * É a identidade que o backfill consolidou e que enxerga os seller groups de
 * todos os logins taggeados (`cliente+log@`, `cliente_go@`, ...). Por isso uma
 * sessão canônica é sempre superior a uma taggeada e nunca deve ser
 * sobrescrita por ela.
 */
export const isCanonicalEmail = (email: string): boolean =>
  !CONTEXT_EMAIL_RE.test(email.toLowerCase());
